import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SharedService } from './core/shared.service';

export const checkInAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const navService = inject(SharedService);

  if (!navService.internalNavigation) {
    router.navigate(['/']);
    return false;
  }
  navService.reset();
  return true;
};
